import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { decorateIntlMessages } from '../rosetta_formatted_message';
import SocialIcon from '../social_icon';
import {get, find, some, isEmpty} from 'lodash';
import PropTypes from 'prop-types';
import { stringify } from 'querystring';
import { forceHTTP } from '../../../utils/url';

const i18nMessages = decorateIntlMessages(__filename, defineMessages({
  paidHashtag: {
    id: 'paid_hashtag',
    description: 'Translation for "#paid" in social share URLs for sponsored stories',
    defaultMessage: '#paid'
  },
  share_button_title: {
    id: 'share_button_title',
    description: 'Share button title attribute content (Share on Pinterest)',
    defaultMessage: 'Share on Pinterest'
  }
}));

function PinterestSocialIcon(props, context) {
  const { parentClass, opener_images, sanitizedTitle, url_full, asset_main: { src_full },
    enableAdTextForShares, intl: { formatMessage } } = props;
  const pinterestOpener = find(opener_images, { label: 'PINTEREST' });

  const pinterestHashtag = get(context, 'edition_data.config.pinterest_hashtag', '#refinery29');
  const paidHashtag = formatMessage(i18nMessages.paidHashtag);
  const hashtags = enableAdTextForShares
    ? [pinterestHashtag, paidHashtag].join(' ')
    : pinterestHashtag;

  const socialURLParams = {
    url: url_full && `${url_full}?utm_source=pinterest&utm_medium=pinterest_share`,
    media: forceHTTP(get(pinterestOpener, 'asset.src.full') || src_full),
    description: sanitizedTitle && `${sanitizedTitle}+${hashtags}`
  };

  if (some(socialURLParams, isEmpty)) {
    return null;
  }

  const querystring = stringify(socialURLParams);
  const socialURL = `https://pinterest.com/pin/create/button/?${querystring}`;

  return (
    <div data-href={socialURL} data-pin-custom="true" style={{ display: 'inline-block' }} role="button" tabIndex={0}>
      <SocialIcon
        parentClass={parentClass}
        url_full={url_full}
        category="Pinterest"
        action="Pin"
        socialURL={socialURL}
        faClassName="pinterest-p"
        title={formatMessage(i18nMessages.share_button_title)}
      />
    </div>
  );
}

PinterestSocialIcon.propTypes = {
  sanitizedTitle: PropTypes.string.isRequired,
  url_full: PropTypes.string.isRequired,
  asset_main: PropTypes.shape({
    src_full: PropTypes.string
  }).isRequired,
  opener_images: PropTypes.arrayOf(PropTypes.shape({
    asset: PropTypes.shape({
      src: PropTypes.shape({
        full: PropTypes.string
      })
    })
  })).isRequired,
  enableAdTextForShares: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired,
  className: PropTypes.string,
  parentClass: PropTypes.string
};

PinterestSocialIcon.defaultProps = {
  sanitizedTitle: '',
  url_full: '',
  asset_main: { src_full: '' },
  opener_images: [{
    asset: {
      src: {
        full: ''
      }
    }
  }],
  enableAdTextForShares: false
};

PinterestSocialIcon.contextTypes = {
  edition_data: PropTypes.shape({
    config: PropTypes.shape({
      pinterest_hashtag: PropTypes.string
    })
  })
};

export default injectIntl(PinterestSocialIcon);
